import { defineMessages } from "react-intl";

const messages = defineMessages({
  appName: {
    id: "fileStorage.components.configForm.appName",
    defaultMessage: "Application name",
  },
  configVersion: {
    id: "fileStorage.components.configForm.configVersion",
    defaultMessage: "Config version",
  },
  createdAt: {
    id: "fileStorage.components.configForm.createdAt",
    defaultMessage: "Created at",
  },
  updatedAt: {
    id: "fileStorage.components.configForm.updatedAt",
    defaultMessage: "Updated at",
  },
  deleted: {
    id: "fileStorage.components.configForm.deleted",
    defaultMessage: "Deleted",
  },
  deletedAt: {
    id: "fileStorage.components.configForm.deletedAt",
    defaultMessage: "Deleted at",
  },
  configPubsubTopic: {
    id: "fileStorage.components.configForm.configPubsubTopic",
    defaultMessage: "Pubsub topic",
  },
  configBucketName: {
    id: "fileStorage.components.configForm.configBucketName",
    defaultMessage: "Bucket name",
  },
  configLifeCycleRetentionPolicy: {
    id: "fileStorage.components.configForm.configLifeCycleRetentionPolicy",
    defaultMessage: "Lifecycle retention policy",
  },
  configAcceptedMimeTypes: {
    id: "fileStorage.components.configForm.configAcceptedMimeTypes",
    defaultMessage: "Accepted mime types",
  },
  configMaxFileSize: {
    id: "fileStorage.components.configForm.configMaxFileSize",
    defaultMessage: "Max file size",
  },
  configReadPermission: {
    id: "fileStorage.components.configForm.configReadPermission",
    defaultMessage: "Read permission",
  },
  configWritePermission: {
    id: "fileStorage.components.configForm.configWritePermission",
    defaultMessage: "Write permission",
  },
  infoName: {
    id: "fileStorage.components.configForm.infoName",
    defaultMessage:
      "A required field that is the name of the application you wish to upload/read files. Only letters, numbers and hyphens accepted. i.e. occ-balancing",
  },
  infoPubSub: {
    id: "fileStorage.components.configForm.infoPubSub",
    defaultMessage:
      "If required this is the GCP Pub/Sub Topic name. i.e. accounts-topic",
  },
  infoBucket: {
    id: "fileStorage.components.configForm.infoBucket",
    defaultMessage:
      "If required this is the name of the bucket GCP will store files. i.e. apex-file-storage-prd-00-file-storage-service-us",
  },
  infoMime: {
    id: "fileStorage.components.configForm.infoMime",
    defaultMessage:
      "If required only files selected can be uploaded to this application. .i.e. csv, png",
  },
  infoFileSize: {
    id: "fileStorage.components.configForm.infoFileSize",
    defaultMessage:
      "If required this is maximum file size that can be stored. i.e. 250mb",
  },
  infoRead: {
    id: "fileStorage.components.configForm.infoRead",
    defaultMessage:
      "If required, specify the legit permission required to read a file. i.e. account.read",
  },
  infoWrite: {
    id: "fileStorage.components.configForm.infoWrite",
    defaultMessage:
      "A required field that indicates the legit permission required to upload a file. i.e. levies.write",
  },
});

export default messages;
